<template lang="pug">
  b-row()
    b-col(cols="4")
      b-row.row-title.pb-3
        b-icon-person-fill.mr-2
        h3.title Datos del Cliente

      //- Datos
      b-row
        b-col.pl-0(cols="5")
          h4.data-label Rut
        b-col(cols="7")
          h4.data-info {{ ovData.rut }}

      b-row
        b-col.pl-0(cols="5")
          h4.data-label Nombre
        b-col(cols="7")
          h4.data-info {{ ovData.nombre }}

      b-row
        b-col.pl-0(cols="5" )
          h4.data-label Apellido
        b-col(cols="7" )
          h4.data-info {{ ovData.apellido }}

      b-row
        b-col.pl-0.pr-0(cols="5" )
          h4.data-label Correo Electrónico
        b-col(cols="7" )
          h4.data-info {{ ovData.correo_electronico }}

      b-row
        b-col.pl-0(cols="5" )
          h4.data-label Teléfono
        b-col(cols="7" )
          h4.data-info {{ ovData.telefono }}

      b-row
        b-col.pl-0(cols="5" )
          h4.data-label Región
        b-col(cols="7" )
          h4.data-info {{ ovData.region }}

      b-row
        b-col.pl-0(cols="5" )
          h4.data-label Comuna
        b-col(cols="7" )
          h4.data-info {{ ovData.comuna }}

      b-row
        b-col.pl-0(cols="5" )
          h4.data-label Dirección
        b-col(cols="7" )
          h4.data-info {{ ovData.direccion }}

      b-row
        b-col.pl-0(:cols="ovData.comentario !== '-' ? '12' : '5'")
          h4.data-label Comentario
        b-col.pl-0(cols="12" v-if="ovData.comentario !== '-'")
          h4.data-info {{ ovData.comentario }}
        b-col(cols="7" v-else)
          h4.data-info {{ ovData.comentario }}


    b-col(cols="8")
      b-row.row-title.pb-3
        b-icon-tools.mr-2
        h3.title Repuestos Solicitados

      //- Información del Equipo
      b-row
        b-col.pl-0(cols="3" )
          h4.data-label N° De Serie Equipo
        b-col.pl-0(cols="9" )
          h4.data-info {{ ovData.numero_serie_equipo }}
      b-row
        b-col.pl-0(:cols="ovData.comentario_cliente !== '-' ? '12' : '3'" )
          h4.data-label Comentario Cliente
        b-col.pl-0(cols="12" v-if="ovData.comentario_cliente !== '-'")
          h4.data-info {{ ovData.comentario_cliente}}
        b-col.pl-0(cols="9" v-else)
          h4.data-info {{ ovData.comentario_cliente}}


      //- Repuestos
      b-row.row-title.pt-1.pb-1(v-for="(repuesto, index) in ovData.repuestos" :key="index")
        h3.title Repuesto {{ index+1 }}

        b-col.pl-0(cols="12")
          h3.data-label.repuesto Categoria del Repuesto
        b-col.pl-0(cols="12")
          h4.data-info.repuesto {{ repuesto.category.name }}

        b-col.pl-0(cols="12")
          h3.data-label.repuesto Comentario
        b-col.pl-0(cols="12")
          h4.data-info.repuesto {{ repuesto.comments }}

</template>

<script>

export default {
  props: {
    ov: {
      type: Object,
      required: true,
    },
  },

  components: {
  },

  computed: {
    ovData () {
      return {
        rut: this.ov.rut || '-',
        nombre: this.ov.nombre || '-',
        apellido: this.ov.apellido || '-',
        correo_electronico: this.ov.correo_electronico || '-',
        telefono: this.ov.telefono || '-',
        region: this.ov.region || '-',
        comuna: this.ov.comuna || '-',
        direccion: this.ov.direccion || '-',
        comentario: this.ov.comentario || '-',
        numero_serie_equipo: this.ov.numero_serie_equipo || '-',
        comentario_cliente: this.ov.comentario || '-',
        repuestos: this.ov.repuestos,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';

.label-text {
  color: $samtek-black !important;
}
.title {
  font-size: 16px;
  font-weight: 700;
  margin: 0;
}
.row-title {
  align-items: center;
}
.data-label {
  font-size: 14px;
  font-weight: 700;
  text-align: left;
  justify-content: left;
  color: #525252;
  margin: 0;
}
.data-info {
  font-size: 14px;
  font-weight: 400;
  color: #525252;
  text-align: left;
}
.repuesto {
  color: #525252;
  font-size: 1rem;
}
</style>
